<template>
  <div class="vx-row">
    <div class="vx-col w-full lg:w-1/1 lg:mt-0 md:mt-0 mt-base">
       <div class="vx-row">
        <div class="vx-col w-full">
          <p v-if="showProductSelection">Select card</p>
          <vs-dropdown v-if="showProductSelection" vs-trigger-click class="cursor-pointer" style="min-width:200px">
            <div class="p-4 shadow border border-solid d-theme-border-grey-light d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
              <span class="mr-2">{{ actionDropdownTitle }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <vs-dropdown-menu class="search-page__more-dropdown">
              <vs-dropdown-item
                v-for="item in productOptions"
                :key="item.title"
                @click="changeProduct(item)"
                >
                {{ item.title }}
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full">
          <vs-button class="float-right my-4" @click="updateDetails">Update</vs-button>
        </div>
      </div>
    </div>
    <vs-collapse class="vx-col w-full lg:w-1/3 lg:mt-0 mt-base">
     <vs-collapse-item class="bg-white">
       <div slot="header">
         Business address
       </div>
        <div class="vx-row mb-4">
          <div class="vx-col w-full">
            <vs-input class="w-full" icon-pack="feather" icon="icon-award" icon-no-border label="Business name" v-model="businessName" />
          </div>
        </div>
        <div class="vx-row mb-4">
          <div class="vx-col w-full">
            <vs-input class="w-full" icon-pack="feather" icon="icon-user" icon-no-border label="Contact name" v-model="contactName" />
          </div>
        </div>
        <div class="vx-row mb-4">
          <div class="vx-col w-full">
            <vs-input type="email" class="w-full" icon-pack="feather" icon="icon-map-pin" icon-no-border label="Address Line 1" v-model="addressLine1" />
          </div>
        </div>
        <div class="vx-row mb-4">
          <div class="vx-col w-full">
            <vs-input class="w-full" icon-pack="feather" icon="icon-map-pin" icon-no-border label="Address Line 2" v-model="addressLine2" />
          </div>
        </div>
        <div class="vx-row mb-4">
          <div class="vx-col w-full">
            <vs-input class="w-full" icon-pack="feather" icon="icon-map-pin" icon-no-border label="Town / City" v-model="city" />
          </div>
        </div>
        <div class="vx-row mb-4">
          <div class="vx-col w-full">
            <vs-input class="w-full" icon-pack="feather" icon="icon-map-pin" icon-no-border label="County / Province" v-model="county" />
          </div>
        </div>
        <div class="vx-row mb-4">
          <div class="vx-col w-full">
            <vs-input class="w-full" icon-pack="feather" icon="icon-map-pin" icon-no-border label="Country" v-model="country" />
          </div>
        </div>
        <div class="vx-row mb-4">
          <div class="vx-col w-full">
            <vs-input class="w-full" icon-pack="feather" icon="icon-map-pin" icon-no-border label="Postcode" v-model="postcode" />
          </div>
        </div>
        <div class="vx-row mb-4">
          <div class="vx-col w-full">
            <vs-input class="w-full" icon-pack="feather" icon="icon-phone" icon-no-border label="Telephone 1" v-model="tel1" />
          </div>
        </div>
        <div class="vx-row mb-4">
          <div class="vx-col w-full">
            <vs-input class="w-full" icon-pack="feather" icon="icon-phone" icon-no-border label="Telephone 2" v-model="tel2" />
          </div>
        </div>
        <div class="vx-row mb-4">
          <div class="vx-col w-full">
            <vs-input class="w-full" icon-pack="feather" icon="icon-mail" icon-no-border label="Business email" v-model="businessEmail" />
          </div>
        </div>
        <div class="vx-row mb-4">
          <div class="vx-col w-full">
            <vs-input class="w-full" icon-pack="feather" icon="icon-dollar-sign" icon-no-border label="Paypal address" v-model="paypal" />
          </div>
        </div>

     </vs-collapse-item>
    </vs-collapse>

    <vs-collapse class="vx-col w-full lg:w-1/3 lg:mt-0 mt-base">
     <vs-collapse-item class="bg-white">
       <div slot="header">
         Websites
       </div>
        <div class="vx-row mb-4 mt-4">
          <div class="vx-col w-full">
            <vs-input class="w-full" icon-pack="feather" icon="icon-link" icon-no-border label="Website 1" v-model="website1" />
          </div>
        </div>
        <div class="vx-row mb-4">
          <div class="vx-col w-full">
            <vs-input type="email" class="w-full" icon-pack="feather" icon="icon-link" icon-no-border label="Website 2" v-model="website2" />
          </div>
        </div>
     </vs-collapse-item>
    </vs-collapse>

      <vs-collapse class="vx-col w-full lg:w-1/3 lg:mt-0 mt-base">
      <vs-collapse-item class="bg-white">
        <div slot="header">
          Social accounts
        </div>
        <div class="vx-row mb-4 mt-4">
          <div class="vx-col w-full">
            <vs-input class="w-full" icon-pack="feather" icon="icon-facebook" icon-no-border label="Facebook" v-model="facebookUsername" />
            <span>facebook.com/{{facebookUsername}}</span>
          </div>
        </div>
        <div class="vx-row mb-4">
          <div class="vx-col w-full">
            <vs-input type="email" class="w-full" icon-pack="feather" icon="icon-twitter" icon-no-border label="Twitter" v-model="twitterUsername" />
            <span>twitter.com/{{twitterUsername}}</span>
          </div>
        </div>
        <div class="vx-row mb-4">
          <div class="vx-col w-full">
            <vs-input class="w-full" icon-pack="feather" icon="icon-instagram" icon-no-border label="Instagram" v-model="instagramUsername" />
            <span>instagram.com/{{instagramUsername}}</span>
          </div>
        </div>
        <div class="vx-row mb-4">
          <div class="vx-col w-full">
            <vs-input class="w-full" icon-pack="feather" icon="icon-linkedin" icon-no-border label="LinkedIn" v-model="linkedinUsername" />
            <span>linkedin.com/in/{{linkedinUsername}}</span>
          </div>
        </div>
      </vs-collapse-item>
    </vs-collapse>

    <!--
    <div class="vx-col w-full lg:w-1/1 lg:mt-0 md:mt-0 mt-base">
      <div class="vx-row">
        <div class="vx-col w-full">
          <vs-button class="float-right my-4" @click="updateDetails">Update</vs-button>
        </div>
      </div>
    </div>
    -->

  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data () {
    return {
      profileCollectionId: '',
      businessName: '',
      businessEmail: '',
      contactName: '',
      addressLine1: '',
      addressLine2: '',
      city: '',
      county: '',
      country: '',
      postcode: '',
      tel1: '',
      tel2: '',
      facebookUsername: '',
      twitterUsername: '',
      instagramUsername: '',
      linkedinUsername: '',
      website1: '',
      website2: '',
      paypal: '',
      showProductSelection: false,
      productOptions: [],
      profileDocId: 'card'
    }
  },
  computed: mapState(['AppActiveUser']),
  created () {
    if (this.AppActiveUser.uid === 0) {
      this.unsubscribe = this.$store.subscribe((mutation, state) => {
        if (mutation.type === 'UPDATE_USER_INFO') {
          if (state.AppActiveUser !== 0) {
            this.getUserProducts()
            this.getDetails()
          }
        }
      })
    } else {
      this.getUserProducts()
      this.getDetails()
    }
  },
  beforeDestroy () {
    const unsubscribe = this.$store.subscribe(() => {})
    unsubscribe()
  },
  methods: {
    getUserProducts () {
      this.$fs.collection('client').doc(this.AppActiveUser.uid).collection('actions').get()
        .then(actionsData => {
          if (actionsData.docs.length > 2) {
            this.showProductSelection = true
            this.actionDropdownTitle = actionsData.docs[0].data().title
            actionsData.docs.forEach(doc => {
              if (doc.data().title !== undefined && !doc.data().title.includes('Keyring')) {
                this.productOptions.push({
                  id: doc.id,
                  title: doc.data().title
                })
              }
            })
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    changeProduct (item) {
      console.log(item)
      this.actionDropdownTitle = item.title
      this.profileDocId = item.id
      this.getDetails()
    },
    getDetails () {
      this.$fs.collection('client').doc(this.AppActiveUser.uid).collection('profile').get()
        .then(docsData => {
          let data = null
          if (docsData.docs.length === 1 || this.profileDocId === 'card') {
            data = docsData.docs.find(doc => !doc.id.includes('card'))
            this.profileCollectionId = data.id
            data = data.data()
          } else {
            data = docsData.docs.find(doc => doc.id === this.profileDocId)
            this.profileCollectionId = data.id
            data = data.data()
          }

          console.log('col', this.profileCollectionId)

          this.businessName = data.businessName
          this.contactName = data.contactName
          this.businessEmail = data.businessEmail
          this.addressLine1 = data.addressLine1
          this.addressLine2 = data.addressLine2
          this.city = data.city
          this.county = data.county
          this.country = data.country
          this.postcode = data.postcode
          this.tel1 = data.tel1
          this.tel2 = data.tel2
          this.facebookUsername = data.facebookUsername
          this.twitterUsername = data.twitterUsername
          this.instagramUsername = data.instagramUsername
          this.linkedinUsername = data.linkedinUsername
          this.website1 = data.website1
          this.website2 = data.website2
          this.paypal = data.paypal
        })
        .catch(error => {
          console.log(error)
        })
    },
    updateDetails () {
      if (this.website1 !== undefined) {
        if (this.website1.includes('https://') || this.website1.includes('http://')) {
          this.website1 = this.website1.replace(/^https?:\/\//, '')
        }
      }

      if (this.website2 !== undefined) {
        if (this.website2.includes('https://') || this.website2.includes('http://')) {
          this.website2 = this.website2.replace(/^https?:\/\//, '')
        }
      }

      this.$fs.collection('client').doc(this.AppActiveUser.uid).collection('profile').doc(this.profileCollectionId).set({
        businessName: this.businessName || '',
        contactName: this.contactName || '',
        businessEmail: this.businessEmail || '',
        addressLine1: this.addressLine1 || '',
        addressLine2: this.addressLine2 || '',
        city: this.city || '',
        county: this.county || '',
        country: this.country || '',
        postcode: this.postcode || '',
        tel1: this.tel1 || '',
        tel2: this.tel2 || '',
        facebookUsername: this.facebookUsername || '',
        twitterUsername: this.twitterUsername || '',
        instagramUsername: this.instagramUsername || '',
        linkedinUsername: this.linkedinUsername || '',
        website1: this.website1 || '',
        website2: this.website2 || '',
        paypal: this.paypal || ''
      }, {merge: true})
        .then(() => {
          this.$vs.notify({
            title: 'Updated',
            text: 'Your details have been updated',
            iconPack: 'feather',
            icon: 'icon-check-circle',
            color: 'success',
            position: 'top-center'
          })
        })
        .catch(error => {
          console.log(error)
        })
    }
  }
}
</script>
